{{#if matchesAllDevices}}
	<strong>{{TR "Alle Geräte"}}</strong>
{{else}}
	{{#each aspects}}
	{{#if available}}
		<strong>{{caption}}</strong>
		<p>
			{{#if containsHtml}}{{{value}}}{{else}}{{value}}{{/if}}
			{{#if hint}}<br><div class="m-t-10"><small><i>{{hint}}</i></small><div>{{/if}}
		</p>
	{{/if}}
	{{/each}}
{{/if}}
